function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { BubbleMenuPlugin } from '@tiptap/extension-bubble-menu';
import { Editor as Editor$1, NodeView } from '@tiptap/core';
export * from '@tiptap/core';
import { FloatingMenuPlugin } from '@tiptap/extension-floating-menu';
import Vue from 'vue';
import { objectProp, booleanProp, functionProp } from 'vue-ts-types';
var BubbleMenu = {
  name: 'BubbleMenu',
  props: {
    pluginKey: {
      type: [String, Object],
      default: 'bubbleMenu'
    },
    editor: {
      type: Object,
      required: true
    },
    updateDelay: {
      type: Number
    },
    tippyOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this = this;

        if (!editor) {
          return;
        }

        this.$nextTick(function () {
          editor.registerPlugin(BubbleMenuPlugin({
            updateDelay: _this.updateDelay,
            editor: editor,
            element: _this.$el,
            pluginKey: _this.pluginKey,
            shouldShow: _this.shouldShow,
            tippyOptions: _this.tippyOptions
          }));
        });
      }
    }
  },
  render: function render(createElement) {
    return createElement('div', {
      style: {
        visibility: 'hidden'
      }
    }, this.$slots.default);
  },
  beforeDestroy: function beforeDestroy() {
    this.editor.unregisterPlugin(this.pluginKey);
  }
};

var Editor = /*#__PURE__*/function (_Editor$) {
  _inherits(Editor, _Editor$);

  var _super = _createSuper(Editor);

  function Editor() {
    var _this2;

    _classCallCheck(this, Editor);

    _this2 = _super.apply(this, arguments);
    _this2.contentComponent = null;
    return _this2;
  }

  return Editor;
}(Editor$1);

var EditorContent = {
  name: 'EditorContent',
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this3 = this;

        if (editor && editor.options.element) {
          this.$nextTick(function () {
            var element = _this3.$el;

            if (!element || !editor.options.element.firstChild) {
              return;
            }

            element.append.apply(element, _toConsumableArray(editor.options.element.childNodes));
            editor.contentComponent = _this3;
            editor.setOptions({
              element: element
            });
            editor.createNodeViews();
          });
        }
      }
    }
  },
  render: function render(createElement) {
    return createElement('div');
  },
  beforeDestroy: function beforeDestroy() {
    var editor = this.editor;

    if (!editor) {
      return;
    }

    if (!editor.isDestroyed) {
      editor.view.setProps({
        nodeViews: {}
      });
    }

    editor.contentComponent = null;

    if (!editor.options.element.firstChild) {
      return;
    }

    var newElement = document.createElement('div');
    newElement.append.apply(newElement, _toConsumableArray(editor.options.element.childNodes));
    editor.setOptions({
      element: newElement
    });
  }
};
var FloatingMenu = {
  name: 'FloatingMenu',
  props: {
    pluginKey: {
      type: [String, Object],
      default: 'floatingMenu'
    },
    editor: {
      type: Object,
      required: true
    },
    tippyOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    shouldShow: {
      type: Function,
      default: null
    }
  },
  watch: {
    editor: {
      immediate: true,
      handler: function handler(editor) {
        var _this4 = this;

        if (!editor) {
          return;
        }

        this.$nextTick(function () {
          editor.registerPlugin(FloatingMenuPlugin({
            pluginKey: _this4.pluginKey,
            editor: editor,
            element: _this4.$el,
            tippyOptions: _this4.tippyOptions,
            shouldShow: _this4.shouldShow
          }));
        });
      }
    }
  },
  render: function render(createElement) {
    return createElement('div', {
      style: {
        visibility: 'hidden'
      }
    }, this.$slots.default);
  },
  beforeDestroy: function beforeDestroy() {
    this.editor.unregisterPlugin(this.pluginKey);
  }
};
var NodeViewContent = {
  props: {
    as: {
      type: String,
      default: 'div'
    }
  },
  render: function render(createElement) {
    return createElement(this.as, {
      style: {
        whiteSpace: 'pre-wrap'
      },
      attrs: {
        'data-node-view-content': ''
      }
    });
  }
};
var NodeViewWrapper = {
  props: {
    as: {
      type: String,
      default: 'div'
    }
  },
  inject: ['onDragStart', 'decorationClasses'],
  render: function render(createElement) {
    return createElement(this.as, {
      class: this.decorationClasses.value,
      style: {
        whiteSpace: 'normal'
      },
      attrs: {
        'data-node-view-wrapper': ''
      },
      on: {
        dragstart: this.onDragStart
      }
    }, this.$slots.default);
  }
};
/**
 * The VueRenderer class is responsible for rendering a Vue component as a ProseMirror node view.
 */

var VueRenderer = /*#__PURE__*/function () {
  function VueRenderer(component, props) {
    _classCallCheck(this, VueRenderer);

    var Component = typeof component === 'function' ? component : Vue.extend(component);
    this.ref = new Component(props).$mount();
  }

  _createClass(VueRenderer, [{
    key: "element",
    get: function get() {
      return this.ref.$el;
    }
  }, {
    key: "updateProps",
    value: function updateProps() {
      var _this5 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _a, _b, _c;

      if (!this.ref.$props) {
        return;
      } // prevents `Avoid mutating a prop directly` error message
      // Fix: `VueNodeViewRenderer` change vue Constructor `config.silent` not working


      var currentVueConstructor = (_c = (_b = (_a = this.ref.$props.editor) === null || _a === void 0 ? void 0 : _a.contentComponent) === null || _b === void 0 ? void 0 : _b.$options._base) !== null && _c !== void 0 ? _c : Vue; // eslint-disable-line

      var originalSilent = currentVueConstructor.config.silent;
      currentVueConstructor.config.silent = true;
      Object.entries(props).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        _this5.ref.$props[key] = value;
      });
      currentVueConstructor.config.silent = originalSilent;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.ref.$destroy();
    }
  }]);

  return VueRenderer;
}();

var nodeViewProps = {
  editor: objectProp().required,
  node: objectProp().required,
  decorations: objectProp().required,
  selected: booleanProp().required,
  extension: objectProp().required,
  getPos: functionProp().required,
  updateAttributes: functionProp().required,
  deleteNode: functionProp().required
};

var VueNodeView = /*#__PURE__*/function (_NodeView) {
  _inherits(VueNodeView, _NodeView);

  var _super2 = _createSuper(VueNodeView);

  function VueNodeView() {
    _classCallCheck(this, VueNodeView);

    return _super2.apply(this, arguments);
  }

  _createClass(VueNodeView, [{
    key: "mount",
    value: function mount() {
      var _this6 = this;

      var _a, _b;

      var props = {
        editor: this.editor,
        node: this.node,
        decorations: this.decorations,
        innerDecorations: this.innerDecorations,
        view: this.view,
        selected: false,
        extension: this.extension,
        HTMLAttributes: this.HTMLAttributes,
        getPos: function getPos() {
          return _this6.getPos();
        },
        updateAttributes: function updateAttributes() {
          var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return _this6.updateAttributes(attributes);
        },
        deleteNode: function deleteNode() {
          return _this6.deleteNode();
        }
      };
      var onDragStart = this.onDragStart.bind(this);
      this.decorationClasses = Vue.observable({
        value: this.getDecorationClasses()
      }); // @ts-ignore

      var vue = (_b = (_a = this.editor.contentComponent) === null || _a === void 0 ? void 0 : _a.$options._base) !== null && _b !== void 0 ? _b : Vue; // eslint-disable-line

      var Component = vue.extend(this.component).extend({
        props: Object.keys(props),
        provide: function provide() {
          return {
            onDragStart: onDragStart,
            decorationClasses: _this6.decorationClasses
          };
        }
      });
      this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this);
      this.editor.on('selectionUpdate', this.handleSelectionUpdate);
      this.renderer = new VueRenderer(Component, {
        parent: this.editor.contentComponent,
        propsData: props
      });
    }
    /**
     * Return the DOM element.
     * This is the element that will be used to display the node view.
     */

  }, {
    key: "dom",
    get: function get() {
      if (!this.renderer.element.hasAttribute('data-node-view-wrapper')) {
        throw Error('Please use the NodeViewWrapper component for your node view.');
      }

      return this.renderer.element;
    }
    /**
     * Return the content DOM element.
     * This is the element that will be used to display the rich-text content of the node.
     */

  }, {
    key: "contentDOM",
    get: function get() {
      if (this.node.isLeaf) {
        return null;
      }

      var contentElement = this.dom.querySelector('[data-node-view-content]');
      return contentElement || this.dom;
    }
    /**
     * On editor selection update, check if the node is selected.
     * If it is, call `selectNode`, otherwise call `deselectNode`.
     */

  }, {
    key: "handleSelectionUpdate",
    value: function handleSelectionUpdate() {
      var _this$editor$state$se = this.editor.state.selection,
          from = _this$editor$state$se.from,
          to = _this$editor$state$se.to;
      var pos = this.getPos();

      if (typeof pos !== 'number') {
        return;
      }

      if (from <= pos && to >= pos + this.node.nodeSize) {
        if (this.renderer.ref.$props.selected) {
          return;
        }

        this.selectNode();
      } else {
        if (!this.renderer.ref.$props.selected) {
          return;
        }

        this.deselectNode();
      }
    }
    /**
     * On update, update the React component.
     * To prevent unnecessary updates, the `update` option can be used.
     */

  }, {
    key: "update",
    value: function update(node, decorations, innerDecorations) {
      var _this7 = this;

      var rerenderComponent = function rerenderComponent(props) {
        _this7.decorationClasses.value = _this7.getDecorationClasses();

        _this7.renderer.updateProps(props);
      };

      if (typeof this.options.update === 'function') {
        var oldNode = this.node;
        var oldDecorations = this.decorations;
        var oldInnerDecorations = this.innerDecorations;
        this.node = node;
        this.decorations = decorations;
        this.innerDecorations = innerDecorations;
        return this.options.update({
          oldNode: oldNode,
          oldDecorations: oldDecorations,
          newNode: node,
          newDecorations: decorations,
          oldInnerDecorations: oldInnerDecorations,
          innerDecorations: innerDecorations,
          updateProps: function updateProps() {
            return rerenderComponent({
              node: node,
              decorations: decorations,
              innerDecorations: innerDecorations
            });
          }
        });
      }

      if (node.type !== this.node.type) {
        return false;
      }

      if (node === this.node && this.decorations === decorations && this.innerDecorations === innerDecorations) {
        return true;
      }

      this.node = node;
      this.decorations = decorations;
      this.innerDecorations = innerDecorations;
      rerenderComponent({
        node: node,
        decorations: decorations,
        innerDecorations: innerDecorations
      });
      return true;
    }
    /**
     * Select the node.
     * Add the `selected` prop and the `ProseMirror-selectednode` class.
     */

  }, {
    key: "selectNode",
    value: function selectNode() {
      this.renderer.updateProps({
        selected: true
      });
      this.renderer.element.classList.add('ProseMirror-selectednode');
    }
    /**
     * Deselect the node.
     * Remove the `selected` prop and the `ProseMirror-selectednode` class.
     */

  }, {
    key: "deselectNode",
    value: function deselectNode() {
      this.renderer.updateProps({
        selected: false
      });
      this.renderer.element.classList.remove('ProseMirror-selectednode');
    }
  }, {
    key: "getDecorationClasses",
    value: function getDecorationClasses() {
      return this.decorations // @ts-ignore
      .map(function (item) {
        return item.type.attrs.class;
      }).flat().join(' ');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer.destroy();
      this.editor.off('selectionUpdate', this.handleSelectionUpdate);
    }
  }]);

  return VueNodeView;
}(NodeView);

function VueNodeViewRenderer(component, options) {
  return function (props) {
    // try to get the parent component
    // this is important for vue devtools to show the component hierarchy correctly
    // maybe it’s `undefined` because <editor-content> isn’t rendered yet
    if (!props.editor.contentComponent) {
      return {};
    }

    return new VueNodeView(component, props, options);
  };
}

export { BubbleMenu, Editor, EditorContent, FloatingMenu, NodeViewContent, NodeViewWrapper, VueNodeViewRenderer, VueRenderer, nodeViewProps };